import { UPDATE_FOOD_QTY_IN_FOOD_ITEM, FETCH_RESTAURANT_FAILED, FETCH_RESTAURANT_REQUESTED, FETCH_RESTAURANT_SUCCEEDED } from "../constants"

const initialState = {
    loading: false,
    restaurantDetails: {},
    error: ''
}

export const restaurantsDetailReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_RESTAURANT_REQUESTED:
            return { ...state, loading: true }
        case FETCH_RESTAURANT_SUCCEEDED:
            return { ...state, loading: false, restaurantDetails: action.payload }
        case FETCH_RESTAURANT_FAILED:
            return { ...state, loading: false, restaurantDetails: {}, error: action.payload, totalCount: 0 }
        case UPDATE_FOOD_QTY_IN_FOOD_ITEM:
            return { ...state, restaurantDetails: { ...state.restaurantDetails, food_items: action.payload } }
        default: return state
    }
}